import type { GlyphName } from '../../lib/glyphs'
import { Glyph } from '../ui/Icon'
import { Reveal } from '../ui/Reveal'
import { SectionHead } from '../ui/SectionHead'
import './Safety.css'

const ITEMS: { cls: string; icon: GlyphName; title: string; body: string; amber?: boolean; meter?: boolean }[] = [
  { cls: 's1', icon: 'id', title: 'Verified people only', body: 'Phone and photo checks before anyone can join or host a plan.' },
  { cls: 's2', icon: 'pin', title: 'Public places by default', body: 'Pins snap to verified venues. Open-air plans show an area, never a doorstep, until the host approves you.' },
  { cls: 's3', icon: 'wf', title: 'Women-first plans', body: "Hosts can open a plan to women only, and everyone sees who's going before they say yes.", amber: true },
  { cls: 's4', icon: 'gauge', title: 'A score that means something', body: 'Show up and it rises. Skip without a word and it falls.', meter: true },
  { cls: 's5', icon: 'shield', title: 'Support, one tap away', body: 'Block anyone instantly, and reach the mauj safety team from inside any plan, any time.' },
]

export function Safety() {
  return (
    <section id="safety">
      <div className="wrap">
        <SectionHead eyebrow="Safety" title={<>Built safe from <em className="s">the first pin.</em></>}>
          Meeting new people only works when everyone can trust the map. Every plan on mauj follows these rules.
        </SectionHead>
        <div className="safe">
          {ITEMS.map((it, i) => (
            <Reveal key={it.title} className={`glass ${it.cls}${it.amber ? ' amber' : ''}`} delay={(i % 3) * 0.08}>
              <span className="shield"><Glyph name={it.icon} /></span>
              <h3>{it.title}</h3>
              <p>{it.body}</p>
              {it.meter && <div className="meter" aria-label="Reliability 98 of 100"><span className="bar"><i /></span><b>98</b></div>}
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  )
}
